import { createComponent } from '@carvana/merch-components';

export const SectionContent = createComponent('div', {
  className: 'flex w-full flex-col gap-40 px-24 -:max-w-[1144px] xl:px-0'
});

export const ExpandedSectionContent = createComponent(SectionContent, {
  className: 'max-w-[1272px]'
});

const Section = createComponent('section', {
  className: 'flex flex-col items-center justify-center pt-40 -:m:py-64'
});

export const SectionLight = createComponent(Section, {
  className: 'bg-white'
});

export const SectionDark = createComponent(Section, {
  className: 'bg-grey-1'
});
